import { executeRequest, Request } from '@jfs/network'
import { getResetPasswordRequestBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  const respData = data?.data
  return respData
}

const forgotPassword = (mobile: string, password: string, otp: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.forgotResetPassword,
    method: 'POST',
    config: sitConfigPreAuth(tokens),
    body: getResetPasswordRequestBody(mobile, otp, password),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { forgotPassword }
